module.exports = __webpack_public_path__ + "assets1763535487631/img/error-404.94756dcf.svg";